import _ from 'lodash';
import { AnyAction } from 'redux';
import { updateInfoBadgeCountOfSideBarHeader } from 'src/adminPanel/components/sideBar/sideBarMenuItems';
import { ROUTE_ADMIN_SERVICE_REPAIR_OFFER } from 'src/config/routes';
import { entityCollectionDefaultState, EntityCollectionState } from 'src/store/entities/types/EntityCollectionState';

import {
    FAILURE_EXPERTISE,
    FAILURE_SEND_REPAIR_OFFER,
    REQUEST_EXPERTISE,
    SUCCESS_EXPERTISE,
} from 'src/store/expertise/actions';

export function expertiseReducer(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_EXPERTISE:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_EXPERTISE: {
            ROUTE_ADMIN_SERVICE_REPAIR_OFFER.infoBadgeCount = action.response.data.length || 0;
            updateInfoBadgeCountOfSideBarHeader();
            return _.assign({}, state, { isFetching: false, content: action.response.data, error: undefined });
        }
        case FAILURE_EXPERTISE:
            return _.assign({}, state, { isFetching: false, content: undefined, error: action.error });
        case FAILURE_SEND_REPAIR_OFFER:
            return _.assign({}, state, { isFetching: false, error: action.error });
        default:
            return state;
    }
}
